let _ = require('underscore')
import { Utils } from '../helpers/utils';

class InputType {
    static get Text() { return "text" }
    static get Date() { return "date" }
    static get Number() { return "number" }
    static get Select() { return "select" }
    static get Search() { return "search" }
}

interface IReportLookUp {
    id: string;
    name: string;
    label: string;
    type: string;
    store?: string;
    displayField?: string;
    idField?: string;
    source?: Array<any>;
    filter?: any;
}

interface IReport {
    name: string;
    title: string;
    notes: string;
    icon?: string;
    dateFilter?: boolean;
    lookUps?: IReportLookUp[];
    query: string;
}

interface IReportGroup {
    name: string;
    reports: IReport[];
}

const Reports: IReportGroup[] = [
    {
        name: "Membership & Transaction Reports",
        reports: [
            {
                name: "membership",
                title: "Membership List",
                notes: "List of all members enrolled on the system indicating their active status.",
                query: "member/report",
                dateFilter: false,
                lookUps: [
                    { id: 'gender', label: "Gender", name: 'gender', store: "genders", source: ['Male', 'Female'], type: InputType.Select },
                    { id: 'status', label: "Status", name: 'status', store: "statuses", source: ['Active', 'InActive', 'Closed'], type: InputType.Select }
                ]
            },
            {
                name: "membershipaccount",
                title: "Accounts Balance",
                notes: "List of all members enrolled on the system indicating their account balances",
                query: "transaction/accountbalance",
                dateFilter: false,
                lookUps: [
                    { id: 'balanceAsAt', label: 'Date (Balance As At)', name: 'balanceAsAt', type: InputType.Date }
                ]
            },
            {
                name: "transactions",
                title: "Transaction List",
                notes: "List of all member transactions for the specified period.",
                query: "transaction/report",
                dateFilter: true,
                lookUps: [
                    { id: 'memberId', label: "Member", name: 'memberId', type: InputType.Search, store: "memberSearchConfig()" },
                    { id: 'type', label: "Type", name: 'type', store: "types", source: ['Saving', 'Withdrawal', 'Interest'], type: InputType.Select }
                ]
            },
            {
                name: "accountstatement",
                title: "Account Statement",
                notes: "Member account statement for the specified period.",
                query: "member/statements",
                dateFilter: true,
                lookUps: [
                    { id: 'id', label: "Member", name: 'id', type: InputType.Search, store: "memberSearchConfig()" }                    
                ]
            },
            {
                name: "monthlybalance",
                title: "Monthly Balances",
                notes: "Displays the monthly balances of transaction for the specified period.",
                query: "transaction/monthlybalance",
                dateFilter: true,
                lookUps: [
                    { id: 'memberId', label: "Member", name: 'memberId', type: InputType.Search, store: "memberSearchConfig()" }                    
                ]
            },
            {
                name: "intereststatement",
                title: "Interest Statement",
                notes: "Displays the interest gained monthly of members for the specified period.",
                query: "transaction/intereststatement",
                dateFilter: true,
                lookUps: [
                    { id: 'memberId', label: "Member", name: 'memberId', type: InputType.Search, store: "memberSearchConfig()" }                    
                ]
            }
        ]
    }
];

class ReportsConfig {
    static getReports() {
        return Reports;
    }

    static reportsList() {
        let reports: IReport[] = [];
        Reports.forEach((group) => {
            reports.push.apply(reports, group.reports)
        })
        return reports;
    }

    static getReport(name: string) {
        let reports: IReport[] = [];
        Reports.forEach((group) => {
            reports.push.apply(reports, group.reports)
        })

        return _.findWhere(reports, { name });
    }

    static makeFilterTemplate(report: IReport) {
        let template = "";
        report.lookUps.forEach((control) => {
            template += this.createControl(control)
        })
        return template
    }

    private static createControl(model: IReportLookUp) {
        let control = ""
        switch (model.type) {
            case InputType.Select:
                let selectId = (model.idField) ? "item." + model.idField : "item.id"
                let selectText = (model.displayField) ? `${selectId} as item.` + model.displayField : `${selectId} as item.name`
                control = `<div class="form-group">
                            <label>${model.label}</label>
                            <select ui-select2="{allowClear:true}" class="form-control" ng-model="rptViewerVm.filter.${model.id}" 
                                ng-options="${(model.id == model.name) ? 'item' : selectText} for item in rptViewerVm.${model.store}">
                                <option></option>
                            </select>
                        </div>`
                break;
            case InputType.Date:
                let key = Utils.makeid(5)
                control = `<div class="form-group">
                                <label>${model.label}</label>
                                <input type="text" uib-datepicker-popup="dd-MMMM-yyyy" class="form-control" ng-model="rptViewerVm.filter.${model.id}"
                                is-open="d${key}.isOpen" ng-click="d${key}.isOpen=true" placeholder="Click to select date" />
                           </div>`
                break;
            case InputType.Text:
                control = `<div class="form-group">
                                <label>${model.label}</label>
                                <input type="text" class="form-control" ng-model="rptViewerVm.filter.${model.id}" />
                           </div>`
                break;
            case InputType.Search:
                control = `<div class="form-group">
                                <label>${model.label}</label>
                                <input ui-select2="rptViewerVm.${model.store}" class="form-control" ng-model="rptViewerVm.filter.${model.id}" />
                           </div>`
                break;
            default:
                break;
        }

        return control;
    }


}

export { IReport, IReportGroup, ReportsConfig, InputType, IReportLookUp }


// WEBPACK FOOTER //
// ./app/reports/report_config.ts